
export default function AutoParts() {
  const categories = [
    {
      name: 'Brakes',
      icon: 'ri-disc-line',
      image: 'https://public.readdy.ai/ai/img_res/a2c7503eec79816e802f3aa5102b17ee.jpg',
      items: ['Brake Pads', 'Brake Rotors', 'Calipers', 'Brake Hardware']
    },
    {
      name: 'Suspension & Steering',
      icon: 'ri-steering-2-line',
      image: 'https://readdy.ai/api/search-image?query=automotive%20suspension%20control%20arm%20and%20ball%20joint%20components%20on%20white%20background%2C%20professional%20product%20photography%2C%20metal%20parts%20with%20clean%20finish%2C%20technical%20automotive%20parts%20catalog%20style&width=600&height=800&seq=parts-002&orientation=portrait',
      items: ['Control Arms', 'Ball Joints', 'Tie Rods', 'Wheel Bearings']
    },
    {
      name: 'Engine & Maintenance',
      icon: 'ri-settings-3-line',
      image: 'https://readdy.ai/api/search-image?query=automotive%20engine%20maintenance%20parts%20including%20oil%20filter%20spark%20plugs%20and%20belts%20on%20clean%20surface%2C%20professional%20product%20photography%2C%20organized%20layout%2C%20automotive%20parts%20catalog%20style&width=600&height=800&seq=parts-003&orientation=portrait',
      items: ['Oil & Filters', 'Spark Plugs', 'Belts & Hoses', 'Alternators & Starters']
    },
    {
      name: 'Cooling System',
      icon: 'ri-temp-cold-line',
      image: 'https://readdy.ai/api/search-image?query=automotive%20radiator%20and%20water%20pump%20cooling%20system%20components%20on%20white%20background%2C%20professional%20product%20photography%2C%20aluminum%20radiator%20with%20clean%20finish%2C%20automotive%20parts%20catalog%20style&width=600&height=800&seq=parts-004&orientation=portrait',
      items: ['Radiators', 'Water Pumps', 'Thermostats', 'Coolant']
    },
    {
      name: 'Electrical & Lighting',
      icon: 'ri-flashlight-line',
      image: 'https://readdy.ai/api/search-image?query=automotive%20headlight%20bulbs%20LED%20lights%20and%20electrical%20components%20on%20clean%20white%20surface%2C%20professional%20product%20photography%2C%20bright%20modern%20car%20lighting%20parts%2C%20automotive%20catalog%20style&width=600&height=800&seq=parts-005&orientation=portrait',
      items: ['Headlights', 'Tail Lights', 'Batteries', 'Sensors & Switches']
    },
    {
      name: 'Exhaust System',
      icon: 'ri-cloud-line',
      image: 'https://readdy.ai/api/search-image?query=automotive%20exhaust%20system%20muffler%20and%20catalytic%20converter%20parts%20on%20white%20background%2C%20professional%20product%20photography%2C%20stainless%20steel%20exhaust%20components%2C%20automotive%20parts%20catalog%20style&width=600&height=800&seq=parts-006&orientation=portrait',
      items: ['Mufflers', 'Catalytic Converters', 'Exhaust Pipes', 'O2 Sensors']
    },
    {
      name: 'Drivetrain',
      icon: 'ri-settings-5-line',
      image: 'https://readdy.ai/api/search-image?query=automotive%20drivetrain%20components%20CV%20axle%20and%20transmission%20parts%20on%20clean%20white%20surface%2C%20professional%20product%20photography%2C%20metal%20mechanical%20parts%2C%20automotive%20catalog%20style&width=600&height=800&seq=parts-007&orientation=portrait',
      items: ['CV Axles', 'U-Joints', 'Clutch Kits', 'Transmission Parts']
    },
    {
      name: 'Body & Accessories',
      icon: 'ri-car-line',
      image: 'https://readdy.ai/api/search-image?query=automotive%20body%20parts%20side%20mirrors%20and%20car%20accessories%20on%20white%20background%2C%20professional%20product%20photography%2C%20chrome%20and%20black%20car%20exterior%20parts%2C%20automotive%20catalog%20style&width=600&height=800&seq=parts-008&orientation=portrait',
      items: ['Mirrors', 'Door Handles', 'Wipers', 'Floor Mats']
    }
  ];

  const featuredProducts = [
    {
      name: 'Premium Ceramic Brake Pads',
      brand: 'Wagner ThermoQuiet',
      price: 'From $49.99',
      image: 'https://readdy.ai/api/search-image?query=premium%20ceramic%20brake%20pads%20set%20in%20packaging%20on%20white%20background%2C%20professional%20product%20photography%2C%20automotive%20brake%20parts%2C%20clean%20studio%20lighting&width=400&height=400&seq=featured-001&orientation=squarish',
      badge: 'Best Seller'
    },
    {
      name: 'Performance Brake Rotors',
      brand: 'Brembo',
      price: 'From $89.99',
      image: 'https://readdy.ai/api/search-image?query=performance%20drilled%20and%20slotted%20brake%20rotor%20disc%20on%20white%20background%2C%20professional%20product%20photography%2C%20shiny%20metal%20automotive%20part%2C%20studio%20lighting&width=400&height=400&seq=featured-002&orientation=squarish',
      badge: 'Popular'
    },
    {
      name: 'Complete Strut Assembly',
      brand: 'Monroe',
      price: 'From $129.99',
      image: 'https://readdy.ai/api/search-image?query=complete%20strut%20assembly%20shock%20absorber%20with%20spring%20on%20white%20background%2C%20professional%20product%20photography%2C%20automotive%20suspension%20part%2C%20clean%20studio%20shot&width=400&height=400&seq=featured-003&orientation=squarish',
      badge: 'Top Rated'
    },
    {
      name: 'LED Headlight Bulbs',
      brand: 'Philips',
      price: 'From $39.99',
      image: 'https://readdy.ai/api/search-image?query=LED%20headlight%20bulb%20pair%20bright%20white%20light%20on%20white%20background%2C%20professional%20product%20photography%2C%20automotive%20lighting%2C%20modern%20car%20bulbs&width=400&height=400&seq=featured-004&orientation=squarish',
      badge: 'New Arrival'
    },
    {
      name: 'Synthetic Motor Oil 5W-30',
      brand: 'Mobil 1',
      price: 'From $34.99',
      image: 'https://readdy.ai/api/search-image?query=synthetic%20motor%20oil%20bottle%205W30%20on%20white%20background%2C%20professional%20product%20photography%2C%20automotive%20lubricant%2C%20clean%20studio%20lighting&width=400&height=400&seq=featured-005&orientation=squarish',
      badge: 'Essential'
    },
    {
      name: 'Premium Car Battery',
      brand: 'ACDelco',
      price: 'From $149.99',
      image: 'https://readdy.ai/api/search-image?query=automotive%20car%20battery%20black%20with%20red%20and%20black%20terminals%20on%20white%20background%2C%20professional%20product%20photography%2C%20clean%20studio%20shot&width=400&height=400&seq=featured-006&orientation=squarish',
      badge: 'Reliable'
    }
  ];

  return (
    <section id="parts" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-rajdhani font-bold text-4xl md:text-5xl text-black mb-4">
            Premium Auto Parts for All Makes &amp; Models
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto leading-relaxed">
            We supply high-quality auto parts for domestic, Asian, and European vehicles. Whether you're a DIY car owner or need professional installation, we've got you covered.
          </p>
        </div>

        {/* Product Categories */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-product-shop>
          {categories.map((category, index) => (
            <div
              key={index}
              className="group relative rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-80 w-full">
                <img
                  src={category.image}
                  alt={category.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              </div>

              <div className="absolute top-5 left-5 w-10 h-10 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-lg">
                <i className={`${category.icon} text-white text-xl`}></i>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="font-rajdhani font-bold text-xl text-white mb-2">
                  {category.name}
                </h3>
                <ul className="space-y-1">
                  {category.items.map((item, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-white/80 text-sm">
                      <span className="w-1.5 h-1.5 bg-red-600 rounded-full flex-shrink-0"></span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Featured Products */}
        <div className="mb-16">
          <div className="text-center mb-10">
            <h3 className="font-rajdhani font-bold text-3xl text-black mb-2">
              Featured Products
            </h3>
            <p className="text-gray-600">Top-quality parts from trusted brands at competitive prices</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-product-shop>
            {featuredProducts.map((product, index) => (
              <div
                key={index}
                className="group bg-gray-50 rounded-xl p-4 hover:shadow-lg transition-all duration-300 cursor-pointer border border-gray-100 hover:border-red-200"
              >
                <div className="relative mb-3">
                  <div className="w-full h-32 rounded-lg overflow-hidden bg-white">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <span className="absolute top-2 left-2 bg-red-600 text-white text-xs px-2 py-1 rounded-full font-medium">
                    {product.badge}
                  </span>
                </div>
                <p className="text-gray-500 text-xs mb-1">{product.brand}</p>
                <h4 className="font-rajdhani font-semibold text-sm text-black mb-2 leading-tight line-clamp-2">
                  {product.name}
                </h4>
                <p className="font-rajdhani font-bold text-red-600 text-sm">{product.price}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Brands We Carry */}
        <div className="bg-gray-50 rounded-2xl p-8 mb-12">
          <h3 className="font-rajdhani font-bold text-2xl text-center text-black mb-6">
            Trusted Brands We Carry
          </h3>
          <div className="flex flex-wrap justify-center items-center gap-8 text-gray-500">
            {['Wagner', 'Brembo', 'Monroe', 'Moog', 'ACDelco', 'Bosch', 'Denso', 'NGK', 'Mobil 1', 'Castrol'].map((brand, index) => (
              <span key={index} className="font-rajdhani font-semibold text-lg hover:text-red-600 transition-colors cursor-pointer">
                {brand}
              </span>
            ))}
          </div>
        </div>

        <div className="text-center">
          <a
            href="tel:905-226-0408"
            className="inline-flex items-center gap-3 bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-full font-rajdhani font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-xl"></i>
            Call for Availability &amp; Pricing
          </a>
          <p className="mt-6 text-gray-600 italic text-sm">
            "If we don't have it in stock, we'll get it fast."
          </p>
        </div>
      </div>
    </section>
  );
}
